module.exports = __webpack_public_path__ + "img/eld.64196581.svg";